import { render, staticRenderFns } from "./localBuy.vue?vue&type=template&id=02dddff3&scoped=true&"
import script from "./localBuy.vue?vue&type=script&lang=js&"
export * from "./localBuy.vue?vue&type=script&lang=js&"
import style0 from "./localBuy.vue?vue&type=style&index=0&id=02dddff3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02dddff3",
  null
  
)

export default component.exports